module.exports = __webpack_public_path__ + "img/electric-motor.a77a72c5.png";